import React from "react";
import './section.css'

export function H5SectionComponent({header, tagline, children, removeTopPadding}) {
    return (
        <div className="section">
            <h5 className={"sectionHeader" + (removeTopPadding ? " removeTopPadding" : "")}>{header}</h5>
            {tagline && <p className="tagline">{tagline}</p>}
            <div className={"sectionBody" + (tagline ? " withTagline" : "")}>
                {children}
            </div>
        </div>
    )
}

export function H2SectionComponent({header, tagline, children, removeTopPadding}) {
    return (
        <div className="section">
            <h2 className={"sectionHeader" + (removeTopPadding ? " removeTopPadding" : "")}>{header}</h2>
            {tagline && <p className="tagline">{tagline}</p>}
            <div className={"sectionBody" + (tagline ? " withTagline" : "")}>
                {children}
            </div>
        </div>
    )
}

export function H3SectionComponent({header, tagline, children, removeTopPadding}) {
    return (
        <div className="section">
            <h3 className={"sectionHeader" + (removeTopPadding ? " removeTopPadding" : "")}>{header}</h3>
            {tagline && <p className="tagline">{tagline}</p>}
            <div className={"sectionBody" + (tagline ? " withTagline" : "")}>
                {children}
            </div>
        </div>
    )
}
